import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isChallengesSingleChoice(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CHALLENGES_SINGLE_CHOICE && typeof label === 'string' && typeof value === 'string';
}
function _formatChallengesSingleChoice(_ref) {
  let {
    field,
    value
  } = _ref;
  if ((value == null ? void 0 : value.length) === 0) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatChallengesSingleChoice(submission) {
  if (isChallengesSingleChoice(submission)) {
    return _formatChallengesSingleChoice(submission);
  }
  return undefined;
}
//# sourceMappingURL=challenges-single-choice-preview.js.map